// Auto-generated from proto definitions. DO NOT EDIT.

export type CorrectionType = 'CORRECTION_TYPE_UNSPECIFIED' | 'CORRECTION_TYPE_SELF' | 'CORRECTION_TYPE_BY_ORDER';

export const CorrectionTypeValues = ['CORRECTION_TYPE_UNSPECIFIED', 'CORRECTION_TYPE_SELF', 'CORRECTION_TYPE_BY_ORDER'] as const;
